import { createReducer } from "redux-create-reducer";
import { I18N_ACTIONS } from "./i18nActions";
const INITIAL_STATE = {
    locale: "en",
    messages: {},
    useBrowserLocale: true
};
export default createReducer(INITIAL_STATE, {
    [I18N_ACTIONS.SELECT_LOCALE](state, action) {
        return {
            ...state,
            locale: action.payload,
            useBrowserLocale: false
        };
    },
    [I18N_ACTIONS.LOCALE_LOADED](state, action) {
        const { locale, messages } = action.payload;
        return {
            ...state,
            messages: {
                ...state.messages,
                [locale]: messages
            }
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/i18n/i18nReducer.ts